export function newFontFace(fontFamily, style, weight) {
    const woff = `url(https://storage.googleapis.com/zoe-storage-prod/fonts/${fontFamily}/${style}/${fontFamily}-${style}.woff) format('woff')`;
    const woff2 = `url(https://storage.googleapis.com/zoe-storage-prod/fonts/${fontFamily}/${style}/${fontFamily}-${style}.woff2) format('woff2')`;
    const source = `${woff}, ${woff2}`;
    const descriptors = {'weight': weight};

    return new FontFace(fontFamily, source, descriptors);
}

export function calcPxToVw(value) {
    return `${100 * value / 640}vw`;
}

export function setBorderRadius(isDesktop, element, amount) {
    const elementHeight = element.clientHeight;

    if (amount === 'full') {
        element.style.borderRadius = `${elementHeight / 2}px`;
        return;
    }

    if (isDesktop.matches) {
        element.style.borderRadius = `${amount}px`;
    } else {
        element.style.borderRadius = this.calcPxToVw(amount);
    }
}
